module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "ded"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ctag1"
  }, [_c('i', [_vm._v("For all women, perhaps especially the younger ones—")]), _c('br'), _vm._v(" "), _c('i', [_vm._v("Jan, Noelle, Kali, Rachel, Luna, Josie, Ariel, Sujata, Hannah, Jessa,")]), _c('br'), _vm._v(" "), _c('i', [_vm._v("Meralyn, Gemma, Jane, Magdalena, Chloe, Ella, Olivia, Janiya,")]), _c('br'), _vm._v(" "), _c('i', [_vm._v("Mirabai,Vernit, and Ava.")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "ctag1 sgc-1"
  }, [_vm._v("\n    May your lives be fulfilling, balanced, and joyful.\n  ")]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "ctag1"
  }, [_c('i', [_vm._v("And for dear Lucy and Lillian. May")]), _c('br'), _vm._v(" "), _c('i', [_vm._v("they each rest in profound peace.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4021225b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/clau_9780738214993_oeb_ded_r1.vue
// module id = 69
// module chunks = 0